/**
 * Tab Component
 *
 * @file tab.js
 */

import $ from "jquery";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel]);

import * as am4core from "@amcharts/amcharts4/core";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import 'swiper/swiper-bundle.css';
const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item");
    const tabsContents = document.querySelectorAll(".a-tab-content");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };

  const defaultTab2 = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item2");
    const tabsContents = document.querySelectorAll(".a-tab-content2");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };

  const defaultTab3 = () => {
    const tabsBtns = document.querySelectorAll(".a-tab-item3");
    const tabsContents = document.querySelectorAll(".a-tab-content3");


    for (let i = 0; i < tabsBtns.length; i += 1) {
      tabsBtns[i].addEventListener('click', function (event) {
        [].forEach.call(tabsBtns, function (el) {
          el.classList.remove('active');
        });
        tabsBtns[i].classList.toggle("active");
        [].forEach.call(tabsContents, function (el) {
          el.classList.remove('tab-active');
        });
        tabsContents[i].classList.toggle("tab-active");
        event.preventDefault();
      });
    }
  };
  const defaultTab4 = () => {
    

  };

  const init = () => {
    defaultTab();
    defaultTab2();
    defaultTab3();
    defaultTab4();
  };

  return {
    init,
  };
})();

export default tabs;
